import React, { Component } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Card, CardBody } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Card2 from './Card2';
import swal from 'sweetalert';
import ApiService from "../../_services/ApiService";
import Config from './../../_config/config';
import Utils from "../../_helpers/utils";

class TabbedCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'tab3',
      buttonFilled: false,
      resource: [],
      pendingResources: [],
      completedResources: [],
      isDevice:"web",
      completedResourcesCount:0,
      totalResourcesCount:0
    };
  }

  componentDidMount() {
    const storedButtonFilled = localStorage.getItem('buttonFilled');
    if (storedButtonFilled) {
      this.setState({ buttonFilled: JSON.parse(storedButtonFilled) });
    }

    //classify device 
    if(Utils.isMobileDevice()) {
      this.isDevice = "mobile";
    }
    else {
      this.isDevice = "web";
    }

    // getResource List
    var postJsonData = {
      "resourceTypeIds": [6, 30]
    };

    ApiService.getTaskResources(postJsonData)
      .then((res) => {
        // SuccessCB
        const resource = res.data;

        const pendingResources = resource.filter(item => !item.completedDate);
        const completedResources = resource.filter(item => item.completedDate);

        this.setState({
          loading: false,
          resource: resource,
          pendingResources: pendingResources,
          completedResources: completedResources,
          completedResourcesCount :completedResources.length,
          totalResourcesCount:pendingResources.length+completedResources.length
        });
      })
      .catch(error => {
        // ErrorCB
        console.log("Resource list Error: " + Config.CONNECTION_ERROR);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.buttonFilled !== this.state.buttonFilled) {
      localStorage.setItem('buttonFilled', JSON.stringify(this.state.buttonFilled));
    }
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  handleButtonClick = () => {
    this.setState((prevState) => ({ buttonFilled: !prevState.buttonFilled }));
  };

  handleCardClick = () => {
    this.history.push('/task_description');
  };

  openUrl(url) {
    window.open(url, "_blank");
  }

  // DateExpired or not check
  isDateExpired(dateString) {
    const date = new Date(dateString);
    const currentDate = new Date();
    if (date < currentDate) {
      return true;
    }
    return false;
  }

markedDone(url,resourceId){

  var enquiryId = localStorage.getItem('enquiryId');
    var postJsonData = {
      "enquiryId":enquiryId,
      "studyResourceId": resourceId
    };
    //send resource api to mark it done
    ApiService.updateTaskResource(postJsonData)
    .then((res) => {
      // SuccessCB
      const response = res.data;
      swal({
        text: response.message,
        icon: "warning",
        button: "Ok",
        allowOutsideClick: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        }).then((exit) => {
        //console.log("Error!");
        });
      this.props.history.push(url);

    })
    .catch(error => {
      // ErrorCB
      console.log("Resource list Error: " + Config.CONNECTION_ERROR);
    });

    
}
  render() {

    const { activeTab, buttonFilled, pendingResources, completedResources } = this.state;

    return (
      <div>
        <div className="text-white text-center py-3" id="headerContainer">{this.state.completedResourcesCount}/{this.state.totalResourcesCount}   Tasks Completed</div>
        <div className="tabbed-cards-container">
          <div className="tabbed-cards-scrollable">
            <Nav tabs className="custom-nav-tabs">
            <NavItem>
                <NavLink
                  className={activeTab === 'tab3' ? 'active' : ''}
                  onClick={() => this.toggleTab('tab3')}
                >
                  Upcoming
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab2' ? 'active' : ''}
                  onClick={() => this.toggleTab('tab2')}
                >
                  Completed
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab1' ? 'active' : ''}
                  onClick={() => this.toggleTab('tab1')}
                >
                  All
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="tab1">
                  {this.state.resource.map((item, index) => (
                    <Card
                      key={index}
                      onClick={() =>
                        this.openUrl(
                          item.typeId === 30
                            ?this.markedDone(item.url,item.id) 
                            : `/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`
                        )
                      }
                      className={
                        item.typeId === 6 ? "material-card" : "zoom-card"
                      } // Add custom class based on item.typeId
                      style={{ backgroundImage:  item.typeId === 6 ?"url('./assets/imgs/"+this.isDevice+"_reading_material.png')":"url('./assets/imgs/"+this.isDevice+"_live_video.png')" }}>
                        <CardBody>
                          {item.completedDate ? (
                            <span className="marked_tab">Completed on {item.completedDate}</span>
                          ) : item.deadline && this.isDateExpired(item.deadlineString) ? (
                            <span className="delayed_tab">Delayed</span>
                          ) : null}
                          <h5>{item.name}</h5>
                          <div className="">
                            {item.typeId === 30 ? <h6>Schedule</h6> : <h6>Deadline</h6>}
                            <h6>{item.deadline}</h6>
                            {item.typeId === 30 ? (
                              <button className="btn" onClick={() => this.markedDone(item.id)}>&nbsp;&nbsp;Join&nbsp;&nbsp;</button>
                            ) : item.completedDate ? (
                              ""
                            ) : (
                              <button
                                className="btn"
                                onClick={() =>
                                  this.openUrl(
                                    `/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`
                                  )
                                }
                              >
                                Mark Done
                              </button>
                            )}
                          </div>
                        </CardBody>
                    </Card>
                  ))}
                </TabPane>

                <TabPane tabId="tab2">
                  {completedResources.map((item, index) => (
                    <Card key={index}  onClick={() =>
                      this.openUrl(
                        item.typeId === 30
                          ? this.markedDone(item.url,item.id) 
                          : `/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`
                      )
                    }
                    className={
                      item.typeId === 6 ? "material-card" : "zoom-card"
                    } // Add custom class based on item.typeId
                    style={{ backgroundImage:  item.typeId === 6 ?"url('./assets/imgs/"+this.isDevice+"_reading_material.png')":"url('./assets/imgs/"+this.isDevice+"_live_video.png')" }}>
                      <CardBody>
                      {item.completedDate ? (
                            <span className="marked_tab">Completed on {item.completedDate}</span>
                          ) : item.deadline && this.isDateExpired(item.deadlineString) ? (
                            <span className="delayed_tab">Delayed</span>
                          ) : null}
                        <div className=''>
                          <h5>{item.name}</h5>
                          {this.isDateExpired(item.deadlineString) && <div className='col-sm-6'><label>delayed</label></div>}
                      
                          {item.typeId === 30 ? <h6>Schedule</h6> : <h6>Deadline</h6>}
                        
                          <h6>{item.deadline}</h6>
                          {/* {item.typeId === 30 ?
                            <button className='btn' onClick={() => this.openUrl(item.url)}>&nbsp;&nbsp;Join&nbsp;&nbsp;</button>
                            : item.completedDate ? "Mark done on" : <button className='btn' onClick={() => this.openUrl(`/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`)}>Mark Done</button>
                          } */}
                        </div>
                      </CardBody>
                    </Card>
                  ))}
                </TabPane>
                <TabPane tabId="tab3">
                  {pendingResources.map((item, index) => (
                    <Card key={index}  onClick={() =>
                      this.openUrl(
                        item.typeId === 30
                          ?this.markedDone(item.url,item.id) 
                          : `/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`
                      )
                    }
                    className={
                      item.typeId === 6 ? "material-card" : "zoom-card"
                    } // Add custom class based on item.typeId
                    style={{ backgroundImage:  item.typeId === 6 ?"url('./assets/imgs/"+this.isDevice+"_reading_material.png')":"url('./assets/imgs/"+this.isDevice+"_live_video.png')" }}>
                        { item.completedDate ? <span className="">Completed on {item.completedDate}</span>:item.deadline&&this.isDateExpired(item.deadlineString) &&(<span className="delayed_tab">Delayed</span>)}
                      <CardBody>
                          <h5>{item.name}</h5>
                          <div className=''>
                            {item.typeId === 30 ? <h6>Schedule</h6> : <h6>Deadline</h6>}
                          <h6>{item.deadline}</h6>
                          {item.typeId === 30 ?
                            <button className='btn' onClick={() => this.openUrl(item.url)}>&nbsp;&nbsp;Join&nbsp;&nbsp;</button>
                            : item.completedDate ? "Mark done on" : <button className='btn' onClick={() => this.openUrl(`/studyResource/${item.typeId}/${item.subTypeId}/details/${item.id}`)}>Mark Done</button>
                          }
                        </div>
                      </CardBody>
                    </Card>
                  ))}
                </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    );
  }
}

export default TabbedCards;
